export const QuickStreamResponseCodes = {
  INSUFFICIENT_FUNDS: "51",
};
